<template>
  <v-container>
    <v-form v-loading="tload" style="max-width:1000px;margin:auto">
      <template>
     
      <v-text-field v-model="formData.chat_tmpid" label="私信提醒"></v-text-field>
      <v-text-field v-model="formData.jd_tmpid" label="接单成功提醒" class="mt-3"></v-text-field>
      <v-text-field v-model="formData.success_tmpid" label="订单送达通知" class="mt-3"></v-text-field>

    
   
        
      </template>
      <v-btn class="mt-3 dark" :loading="tload" @click="submit()">保存</v-btn>
    </v-form>
  </v-container>
</template>

<script>
let _this;
export default {
  props: {
    load: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        chat_tmpid:'',
        jd_tmpid:'',
        success_tmpid:''
      },
      pageLoad: this.load,
      tload: false
    };
  },
  watch: {
    load(val) {
      if (val) {
        this.pageLoad = val;
      }
    },
    pageLoad(val) {
      if (val) {
        this.getConfig();
      }
    }
  },

  mounted() {
    _this = this;
    _this.getConfig();
  },
  methods: {
    //获取配置
    async getConfig() {
      _this.tload = true;
      const res = await this.$post(
        "admin/getNotice",
      );
      _this.tload = false;
      if (res.errno == 0) {
        if (res.data) {
          _this.formData = res.data;
        }
      }
    },
    async submit() {
      this.tload = true;
      const res = await this.$post(
        "admin/updateNotice",
        this.formData,
      );
      this.tload = false;

      if (res.errno === 0) {
        _this.$message({
          showClose: true,
          message: res.data,
          type: "success"
        });
      }
    }
  }
};
</script>
